export const PUBLISHERS_NON_SELECTED = "PUBLISHERS_NON_SELECTED";
export const PUBLISHERS_PARTIALLY_SELECTED = "PUBLISHERS_PARTIALLY_SELECTED";
export const PUBLISHERS_ALL_SELECTED = "PUBLISHERS_ALL_SELECTED";

export const MAX_NUMBER_OF_SELECTED_PUBLISHERS = 200;
export const PUBLISHERS_EXCEEDED_MAX_SELECTED =
  "PUBLISHERS_EXCEEDED_MAX_SELECTED";
